export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 1,
    "title": "What is artificial intelligence (AI)?",
    "description": "The development of computer systems capable of performing tasks that typically require human intelligence, including:\nVisual perception\nSpeech recognition\nDecision-making\nLanguage translation"
  },
  {
    "id": 2,
    "topic_id": 1,
    "title": "What is machine learning (ML)?",
    "description": "A subset of AI that focuses on algorithms and statistical models that enable computers to:\nLearn from data\nImprove performance through experience\nMake predictions without explicit programming\nIdentify patterns in data"
  },
  {
    "id": 3,
    "topic_id": 2,
    "title": "What is generative AI?",
    "description": "AI systems that can create new content, including:\nText\nImages\nMusic\nVideo based on patterns learned from training data"
  },
  {
    "id": 4,
    "topic_id": 1,
    "title": "What is deep learning?",
    "description": "A specialized subset of ML that can process unstructured data effectively and uses:\nMultiple layers of neural networks\nAutomatic feature learning\nHierarchical data representation"
  },
  {
    "id": 5,
    "topic_id": 2,
    "title": "What are large language models (LLMs)?",
    "description": "Advanced AI models that:\nProcess and generate human-like text\nAre trained on massive datasets\nUse transformer architecture\nCan perform various language tasks like summarizations, classification, entity extraction, etc."
  },
  {
    "id": 6,
    "topic_id": 2,
    "title": "What are foundation models?",
    "description": "Large-scale AI models that:\nAre pre-trained on vast amounts of data\nCan be adapted for multiple tasks\nSupport transfer learning\nCan work across different data modalities"
  },
  {
    "id": 7,
    "topic_id": 1,
    "title": "What is a neural network?",
    "description": "A machine learning model inspired by the human brain that consists of:\nInput layer\nHidden layers (optional)\nOutput layer\nWeights and biases\nActivation functions"
  },
  {
    "id": 8,
    "topic_id": 2,
    "title": "What are GANs (Generative Adversarial Networks)?",
    "description": "A generative AI architecture featuring:\nGenerator (creates content)\nDiscriminator (evaluates content)\nCompetitive training process used for creating realistic synthetic data"
  },
  {
    "id": 9,
    "topic_id": 1,
    "title": "What are transformers?",
    "description": "A neural network architecture that:\nUses self-attention mechanism\nProcesses entire sequences in parallel\nRevolutionized NLP\nCan handle multiple data types\nPowers modern language models"
  },
  {
    "id": 10,
    "topic_id": 3,
    "title": "What is transfer learning?",
    "description": "A technique that:\nUses models trained on one task for another task\nFine tunes pre-trained models\nReduces training time and data requirements\nImproves model performance common in foundation models and LLMs"
  },
  {
    "id": 11,
    "topic_id": 1,
    "title": "When is AI/ML not suitable for a business use case?",
    "description": "Lack of quality/labeled data\nCases requiring 100 percent accuracy\nWell-defined rules/logic exists\nAmbiguous business objectives\nStrict ethical/regulatory constraints\nBasic automation needs"
  },
  {
    "id": 12,
    "topic_id": 1,
    "title": "What are the key metrics used to evaluate regression models?",
    "description": "Mean Absolute Error (MAE)\nMean Squared Error (MSE)\nRoot Mean Squared Error (RMSE)\nThese measure differences between predicted and actual continuous values."
  },
  {
    "id": 13,
    "topic_id": 3,
    "title": "What is the purpose of a confusion matrix in classification tasks?",
    "description": "A confusion matrix evaluates classification model performance by showing:\nTrue Positives (TP)\nTrue Negatives (TN)\nFalse Positives (FP)\nFalse Negatives (FN)\nA confusion matrix helps calculate accuracy, precision, recall, and F1 score."
  },
  {
    "id": 14,
    "topic_id": 1,
    "title": "What are the three main categories of ML techniques and their purposes?",
    "description": "1. Regression: Predicts continuous values\n2. Classification: Assigns categories/labels\n3. Clustering: Groups similar data points (unsupervised)"
  },
  {
    "id": 15,
    "topic_id": 1,
    "title": "Name the key use cases for computer vision (CV) in enterprise applications:",
    "description": "Image classification\nObject detection\nImage segmentation\nFacial recognition\nCommon architectures: CNNs with attention mechanisms"
  },
  {
    "id": 16,
    "topic_id": 1,
    "title": "What are the primary NLP use cases in enterprise applications?",
    "description": "Text classification\nNamed entity recognition (NER)\nMachine translation\nQuestion answering common architectures: RNNs, LSTMs, and transformers"
  },
  {
    "id": 17,
    "topic_id": 2,
    "title": "What are the key enterprise applications of generative AI?",
    "description": "Summarization\nChatbots\nCode generation\nEnterprise search\nContent generation\nDocument analysis"
  },
  {
    "id": 18,
    "topic_id": 1,
    "title": "What is the high-level workflow for implementing deep learning solutions?",
    "description": "1. Define problem\n2. Prepare data\n3. Choose algorithm\n4. Train model\n5. Evaluate model\n6. Iterate/optimize\n7. Deploy/monitor"
  },
  {
    "id": 19,
    "topic_id": 1,
    "title": "What are the main cost optimization use cases for AI/ML?",
    "description": "Manufacturing energy optimization\nRoute planning in logistics\nEnergy demand prediction\nPricing strategy optimization\nDrug discovery cost reduction"
  },
  {
    "id": 20,
    "topic_id": 1,
    "title": "What are the key components of enhanced decision-making use cases in AI?",
    "description": "Healthcare: Disease diagnosis/treatment planning\nFinance: Investment decisions/risk assessment\nLogistics: Supply chain optimization\nManufacturing: Production scheduling\nFocus on data-driven insights for confident decision-making."
  },
  {
    "id": 21,
    "topic_id": 2,
    "title": "What are the three main categories of AWS AI/ML services?",
    "description": "1. Generative AI services (e.g., Amazon Bedrock, Amazon Q)\n2. AI services (pre-trained APIs like Comprehend and Textract)\n3. ML services (SageMaker family for end-to-end ML development"
  },
  {
    "id": 22,
    "topic_id": 2,
    "title": "What are the key features of Amazon Bedrock?",
    "description": "Choice of foundation models\nBuilt-in guardrails\nAgents for task execution\nKnowledge bases for RAG\nModel customization options\nData automation capabilities\nReal-time model evaluation\nServerless inference"
  },
  {
    "id": 23,
    "topic_id": 2,
    "title": "What are the main components of Amazon Q and their purposes?",
    "description": "1. Amazon Q for Business:\nEnterprise search, Content generation, Task automation, Data analysis\n2. Amazon Q for Developers:\nCode assistance. Application testing. Security scanning. AWS resource optimization"
  },
  {
    "id": 24,
    "topic_id": 2,
    "title": "What are the four key capabilities of Amazon SageMaker Studio?",
    "description": "1. Prepare data (Data Wrangler)\n2. Build with notebooks (Code Editor, JupyterLab)\n3. Train and tune models (HPO)\n4. Deploy and monitor plus horizontal capabilities:\nHuman-in-the-loop\nMLOps\nResponsible AI\nGovernance"
  },
  {
    "id": 25,
    "topic_id": 2,
    "title": "What are the main AWS AI services for processing text and documents?",
    "description": "Amazon Comprehend: Natural language processing\nAmazon Textract: Document processing\nAmazon Translate: Language translation\nAmazon Transcribe: Speech-to-text\nEach service has specific use cases and integration capabilities."
  },
  {
    "id": 26,
    "topic_id": 2,
    "title": "What are the pricing models for Amazon Bedrock?",
    "description": "1. On-demand:\nPay-per-use\nBased on tokens processed\nNo upfront commitment\n2. Provisioned throughput:\nReserved capacity\nFixed hourly rate\nAvailable in one-month or six-month terms."
  },
  {
    "id": 27,
    "topic_id": 2,
    "title": "What are the different SageMaker tools and their purposes?",
    "description": "SageMaker Studio: Full IDE for ML development\nSageMaker Canvas: No-code ML tool\nSageMaker JumpStart: Pre-built models and solutions\nSageMaker Studio Lab: Free environment for learning Each targets different user personas and use cases"
  },
  {
    "id": 28,
    "topic_id": 2,
    "title": "What are the key features of Amazon Comprehend?",
    "description": "Entity recognition\nKey phrase detection\nSentiment analysis\nTopic modeling\nCustom entity recognition\nLanguage detection\nComprehend medical for healthcare"
  },
  {
    "id": 29,
    "topic_id": 2,
    "title": "What are the main benefits of using AWS managed AI services?",
    "description": "Reduced infrastructure management\nPay-as-you-go pricing\nPre-trained models\nEasy API integration\nScalability\nSecurity and compliance\nRegular updates and improvements"
  },
  {
    "id": 30,
    "topic_id": 5,
    "title": "What are the key components of ML Governance in SageMaker?",
    "description": "SageMaker Experiments: Track and organize training\nModel Registry: Version control and approval\nModel Monitoring: Track drift and bias\nAutomated documentation\nAudit trails\nCompliance controls"
  },
  {
    "id": 31,
    "topic_id": 3,
    "title": "What are the key factors to consider when selecting a foundation model?",
    "description": "1. Modality support and integration\n2. Multilingual capabilities\n3. Cost-performance ratio\n4. Latency requirements\n5. Infrastructure needs\n6. Model size and complexity\n7. Service level agreements (SLAs)\n8. Security and compliance requirements"
  },
  {
    "id": 32,
    "topic_id": 4,
    "title": "What key information should you look for in a model card?",
    "description": "1. Technical specifications\n2. Performance characteristics\n3. Supported features\n4. Ethical considerations\n5. Implementation requirements\n6. Intended use cases\n7. Known limitations\n8. Benchmark results"
  },
  {
    "id": 33,
    "topic_id": 3,
    "title": "What are the main inference parameters that affect model output, and how do they impact generation?",
    "description": "1. Temperature: Controls randomness/creativity (0.0–2.0)\n2. Top-P: Controls cumulative probability distribution\n3. Top-K: Limits token consideration set\n4. Maximum output length: Controls response length\n5. Stop sequences: Defines where generation should end"
  },
  {
    "id": 34,
    "topic_id": 3,
    "title": "How does temperature setting affect model output and when should you use different settings?",
    "description": "Low temperature (0.0–0.3): More deterministic response\nModerate temperature (0.3–0.7): Mix of creativity and determinism\nHigh temperature (0.7–1.0): More creative response"
  },
  {
    "id": 35,
    "topic_id": 3,
    "title": "What are the key prompt engineering techniques for improving model performance?",
    "description": "1. Providing clear instructions\n2. Constraining outputs\n3. Role playing\n4. Using examples in context\n5. Handling long context\n6. Thinking step by step (chain of thought)\n7. Specifying formats\n8. Adhering to length constraints"
  },
  {
    "id": 36,
    "topic_id": 5,
    "title": "What are the common security risks in prompt engineering?",
    "description": "1. Prompt injection\n2. Prompt leakage\n3. Prompt poisoning\n4. Jailbreaking attempts\n5. Inconsistent outputs"
  },
  {
    "id": 37,
    "topic_id": 3,
    "title": "What are the best practices for handling long context in foundation models?",
    "description": "1. Use quotation extraction before analysis\n2. Implement chunking strategies\n3. Use summarization techniques\n4. Prioritize relevant sections\n5. Consider model-specific context windows\n6. Monitor for context dilution\n7. Test performance with varying context lengths"
  },
  {
    "id": 38,
    "topic_id": 3,
    "title": "What are the key cost optimization strategies in prompt engineering?",
    "description": "1. Craft concise prompts\n2. Break down complex tasks\n3. Choose appropriate model size\n4. Use batch processing\n5. Implement caching\n6. Consider fine-tuning for recurring tasks\n7. Monitor and adjust strategies regularly"
  },
  {
    "id": 39,
    "topic_id": 3,
    "title": "What is chain-of-thought (CoT) reasoning and when should you use it?",
    "description": "CoT is a technique that:\nBreaks down complex problems into steps\nShows explicit reasoning process\nImproves accuracy for complex tasks\nCoT is best for:\nMathematical problems\nLogic puzzles\nMulti-step reasoning tasks\nComplex analysis"
  },
  {
    "id": 40,
    "topic_id": 3,
    "title": "What are the key considerations for format constraints in prompts?",
    "description": "1. Use clear delimiters (XML tags and triple quotes)\n2. Specify exact output structure\n3. Provide example formats\n4. Include validation rules\n5. Define error handling\n6. Consider JSON/structured outputs for parsing\n7. Test format consistency"
  },
  {
    "id": 41,
    "topic_id": 4,
    "title": "What are the key principles of responsible AI?",
    "description": "1. AI governance\n2. Bias detection and fairness\n3. Transparency and explainability\n4. Evaluation and monitoring\n5. Legal and ethical considerations\n6. Human-centered design\n7. Security and privacy\n8. Accountability"
  },
  {
    "id": 42,
    "topic_id": 5,
    "title": "How does Amazon SageMaker Model Registry support ML governance?",
    "description": "Centralized repository for model cataloging\nVersion control and tracking\nCustom lifecycle stages (dev, test, and prod)\nApproval workflows\nModel lineage tracking\nMetadata management\nIntegration with model cards\nAudit trail maintenance"
  },
  {
    "id": 43,
    "topic_id": 5,
    "title": "What are the main components of Amazon SageMaker Clarify?",
    "description": "1. Bias detection: Pre- and post-training bias analysis\n2. Explainability: Feature attribution methods\n3. Model quality monitoring: Performance metrics tracking\n4. Data quality checks: Drift detection\n5. Foundation model evaluation: Accuracy, robustness, toxicity\n6. Compliance support: Regulatory alignment"
  },
  {
    "id": 44,
    "topic_id": 5,
    "title": "What are the key features of Amazon Bedrock Guardrails?",
    "description": "1. Denied topics: Restrict specific discussion areas\n2. Content filters: Block harmful content\n3. Sensitive information filters: Protect PII\n4. Contextual grounding checks: Prevent hallucinations\n5. Word filters: Block specific terms\n6. Policy enforcement: Apply the Guardrail API"
  },
  {
    "id": 45,
    "topic_id": 5,
    "title": "What are the steps in the ML governance workflow with SageMaker?",
    "description": "1. Define the ML use case\n2. Initiate use case approval\n3. Create the ML project\n4. Manage the model lifecycle\n5. Governance approval\n6. Access data/model quality\n7. Approve production deployment\n8. Monitor production quality"
  },
  {
    "id": 46,
    "topic_id": 3,
    "title": "What metrics does Amazon Bedrock use for automated model evaluation?",
    "description": "Key Metrics include:\nAccuracy: Correctness of outputs\nRobustness: Resilience to input variations\nToxicity: Harmful content detection\nCoherence: Logical flow\nRelevance: Context appropriateness\nSafety: Ethical compliance"
  },
  {
    "id": 47,
    "topic_id": 3,
    "title": "What is LLM-as-a-judge in Amazon Bedrock and what does it evaluate?",
    "description": "It’s an automated evaluation feature that assesses:\nCorrectness, Completeness, Faithfulness, Helpfulness, Coherence, Relevance, Instruction compliance, Safety monitoring, Scores are normalized from 0 to 1"
  },
  {
    "id": 48,
    "topic_id": 3,
    "title": "What are the key components of RAG evaluation in Amazon Bedrock?",
    "description": "Context relevance\nContext coverage\nCorrectness\nCompleteness\nFaithfulness\nHarmfulness\nAnswer refusal\nStereotyping"
  },
  {
    "id": 49,
    "topic_id": 5,
    "title": "What types of quality checks does SageMaker Clarify perform?",
    "description": "1. Model quality checks:\nBias detection\nPerformance metrics\nFeature attribution\n2. Data quality checks:\nBaseline comparison\nDrift detection\nStatistical analysis\nReal-time monitoring"
  },
  {
    "id": 50,
    "topic_id": 5,
    "title": "What are the key considerations for continuous model monitoring?",
    "description": "1. Data drift detection\n2. Performance degradation\n3. Bias emergence\n4. Quality metrics tracking\n5. Regulatory compliance\n6. Security monitoring\n7. Alert systems\n8. Automated interventions"
  },
  {
    "id": 51,
    "topic_id": 5,
    "title": "What are the three pillars of AI system protection and how do they differ?",
    "description": "1. Security: Protects data, assets, and infrastructure (confidentiality, integrity, availability)\n2. Governance: Framework for optimizing value and managing risks\n3. Compliance: Ensures adherence to policies, standards, and regulations\nKey difference: Each serves distinct yet interconnected purposes for protecting AI systems."
  },
  {
    "id": 52,
    "topic_id": 5,
    "title": "How does AWS's shared responsibility model work for AI security?",
    "description": "AWS responsibilities (security of the cloud):\nMaintains and protects core infrastructure\nSecures data centers and networks\nRegular third-party audits\nCustomer responsibilities (security in the cloud):\nSecure use of AWS services\nData security\nAccess management\nCompliance with regulations\nWhat are the main adversarial tactics against AI systems according to MITRE's ATLAS framework?\n1. Reconnaissance: Gathering information about AI systems\n2. Resource development: Preparing resources for attacks\n3. Execution: Running malicious operations\nKey areas to protect:\nAPI access\nModel endpoints\nTraining data\nInfrastructure"
  },
  {
    "id": 53,
    "topic_id": 5,
    "title": "What are the five scopes in the Generative AI Security Scoping matrix?",
    "description": "1. Consumer applications (public GenAI services)\n2. Enterprise applications (integrated GenAI features)\n3. Applications using pre-trained models\n4. Fine-tuned models with organizational data\n5. Self-trained models from scratch\nEach scope requires different security considerations"
  },
  {
    "id": 54,
    "topic_id": 1,
    "title": "What are the key components of AI data lifecycle management?",
    "description": "1. Data collection\n2. Data processing\n3. Data storage\n4. Analysis and model training\n5. Model deployment\n6. Monitoring and maintenance\nEach stage requires specific security and governance controls."
  },
  {
    "id": 55,
    "topic_id": 5,
    "title": "What are the main compliance frameworks relevant for AI systems on AWS?",
    "description": "1. ISO/IEC JTC 1/SC 42: International AI standards\n2. GDPR: European data protection\n3. HIPAA: Healthcare data protection\n4. SOC 2: Service organization controls"
  },
  {
    "id": 56,
    "topic_id": 5,
    "title": "What AWS services help manage AI compliance and how do they do so?",
    "description": "1. AWS Config: Resource configuration monitoring\n2. AWS Audit Manager: Automated compliance assessment\n3. AWS Artifact: Access to compliance reports\nTogether they provide:\nContinuous monitoring\nAutomated evidence collection\nDocumentation access\nCompliance reporting"
  },
  {
    "id": 57,
    "topic_id": 5,
    "title": "What are the key security considerations for prompt engineering?",
    "description": "Common attack types:\nPrompted persona switches\nExtracting prompt templates\nIgnoring prompt templates\nAlternating languages\nExtracting conversation history mitigation:\nInput validation\nOutput filtering\nRobust guardrails\nWhat are the main components of HIPAA compliance for AI systems?\nThree core rules:\nPrivacy rule: Governs PHI use and disclosure\nSecurity rule: Mandates ePHI safeguards\nBreach notification rule: Requires reporting unauthorized disclosures\nKey requirements:\nMinimum necessary standard:\nAccess controls\nEncryption\nAudit trails"
  },
  {
    "id": 58,
    "topic_id": 5,
    "title": "What are the data retention considerations for AI systems?",
    "description": "Key requirements:\nClear retention policies\nData classification\nAutomated lifecycle management\nRegular audits\nCompliance with regulations\nSecure deletion procedures\nDocumentation of retention periods\nAccess controls"
  },
  {
    "id": 59,
    "topic_id": 3,
    "title": "What are the four main model customization techniques available for foundation models?",
    "description": "1.\tIn-context learning\n2.\tRetrieval-Augmented Generation (RAG)\n3.\tFine-tuning\n4.\tPre-training"
  },
  {
    "id": 60,
    "topic_id": 2,
    "title": "What is the key difference between Causal Language Modeling (CLM) and Masked Language Modeling (MLM)?",
    "description": "CLM predicts the next token based only on preceding tokens (unidirectional), while MLM predicts masked tokens using both left and right context (bidirectional)."
  },
  {
    "id": 61,
    "topic_id": 2,
    "title": "What are the two main AWS services that support model customization of foundation models?",
    "description": "Amazon SageMaker and Amazon Bedrock"
  },
  {
    "id": 62,
    "topic_id": 3,
    "title": "What is the primary advantage of Parameter Efficient Fine-Tuning (PEFT) techniques like LoRA?",
    "description": "They allow model customization by updating only a small subset of parameters instead of the entire model, reducing computational costs while maintaining performance."
  },
  {
    "id": 63,
    "topic_id": 2,
    "title": "What are the two options SageMaker provides for distributed training?",
    "description": "SageMaker Training Jobs: For managed on-demand training\nSageMaker HyperPod: For persistent clusters with more control"
  },
  {
    "id": 64,
    "topic_id": 3,
    "title": "What is SageMaker Model Monitor used for in model evaluation?",
    "description": "It tracks performance metrics in production to ensure the model maintains its effectiveness over time after deployment."
  },
  {
    "id": 65,
    "topic_id": 3,
    "title": "What are the three key metrics that Bedrock evaluations can compute for foundation models?",
    "description": "1.\tSemantic robustness\n2.\tCorrectness\n3.\tToxicity"
  },
  {
    "id": 66,
    "topic_id": 3,
    "title": "What is the purpose of continuous pre-training (domain adaptation)?",
    "description": "It extends fine-tuning by retraining a foundation model on domain-specific data while maintaining its broader capabilities. It's useful for specialized fields like law or medicine."
  },
  {
    "id": 67,
    "topic_id": 3,
    "title": "What technique helps prevent catastrophic forgetting during continuous pre-training?",
    "description": "Combining domain-specific examples with a small subset of the original pre-training data during training."
  },
  {
    "id": 68,
    "topic_id": 2,
    "title": "What two primary methods does SageMaker provide for distributed data parallelism?",
    "description": "SageMaker Distributed Data Parallelism Library (SMDDP)\nSageMaker Model Parallelism (SMP) Library"
  },
  {
    "id": 69,
    "topic_id": 1,
    "title": "What are the five key phases of MLOps implementation in an organization?",
    "description": "1.\tExperimentation\n2.\tRepeatable processes\n3.\tBuilding scalable systems\n4.\tDeploying to production\n5.\tModel monitoring"
  },
  {
    "id": 70,
    "topic_id": 2,
    "title": "What are the four main types of inference options available in Amazon SageMaker?",
    "description": "1.\tReal-time inference\n2.\tBatch inference\n3.\tAsynchronous inference\n4.\tServerless inference"
  },
  {
    "id": 71,
    "topic_id": 1,
    "title": "What is the purpose of Amazon SageMaker Model Registry in MLOps?",
    "description": "It manages and versions models, and it tracks metadata, training parameters, performance metrics, and validation results to ensure only well-tested models reach production."
  },
  {
    "id": 72,
    "topic_id": 2,
    "title": "How does SageMaker Multi-Model Endpoints optimize resource usage?",
    "description": "It allows multiple models to be hosted on a single endpoint, dynamically loading them into memory as needed. This reduces costs and simplifies deployment management."
  },
  {
    "id": 73,
    "topic_id": 2,
    "title": "What are three key inference optimization techniques for LLMs on SageMaker?",
    "description": "1.\tModel distillation\n2.\tQuantization\n3.\tSpeculative decoding"
  },
  {
    "id": 74,
    "topic_id": 3,
    "title": "What is the difference between shadow testing and rolling deployments in SageMaker?",
    "description": "Shadow testing routes traffic copies to test new models without affecting user responses, while rolling deployments gradually shift actual traffic from old to new versions."
  },
  {
    "id": 75,
    "topic_id": 1,
    "title": "What automation tools does AWS provide for MLOps workflows?",
    "description": "1.\tSageMaker Pipelines\n2.\tAWS Step Functions\n3.\tMLFlow integration\n4.\tApache Airflow support"
  },
  {
    "id": 76,
    "topic_id": 2,
    "title": "When should you choose SageMaker Async Inference over Real-time Inference?",
    "description": "Use Async Inference when predictions take longer to compute, payloads are large, or an immediate response isn’t required. It queues requests and processes them as resources become available."
  },
  {
    "id": 77,
    "topic_id": 3,
    "title": "What are the key components that SageMaker Model Monitor tracks in production?",
    "description": "It monitors model performance, data drift, feature attribution drift, and bias drift by analyzing input/output in production traffic."
  },
  {
    "id": 78,
    "topic_id": 1,
    "title": "What is the purpose of MLFlow integration in SageMaker?",
    "description": "It provides experiment tracking, model versioning, and lifecycle management capabilities, allowing teams to log experiments, compare runs, and manage model transitions through different stages."
  },
  {
    "id": 79,
    "topic_id": 200,
    "title": "Understand key AI terminology.",
    "description": "Familiarize yourself with fundamental terms such as artificial intelligence (AI), machine learning (ML), deep learning, neural networks, computer vision, natural language processing (NLP), models, algorithms, training, inferencing, and large language models (LLMs). While the chapter explored several deeper concepts, focus additionally on terms that represent techniques that are still used today, for example back propagation, feature engineering, and inference techniques."
  },
  {
    "id": 80,
    "topic_id": 200,
    "title": "Differentiate among AI, ML, and deep learning.",
    "description": "Know the similarities and distinctions among these three fields, particularly how they relate to each other and their roles in developing intelligent systems."
  },
  {
    "id": 81,
    "topic_id": 200,
    "title": "Identify types of inferencing methods.",
    "description": "Be able to explain batch processing, real-time, and asynchronous inferencing, along with their respective use cases and implications for AI model deployment."
  },
  {
    "id": 82,
    "topic_id": 200,
    "title": "Recognize various data types in AI models.",
    "description": "Understand the differences between labeled and unlabeled data, and the distinctions among structured data (tabular, time-series) and unstructured data (images, text, video)."
  },
  {
    "id": 83,
    "topic_id": 200,
    "title": "Differentiate learning paradigms.",
    "description": "Be familiar with supervised learning, unsupervised learning, and reinforcement learning, including their applications and how they relate to the data used."
  },
  {
    "id": 84,
    "topic_id": 200,
    "title": "Apply knowledge to real-world scenarios.",
    "description": "Be prepared to discuss how the concepts of AI, data types, and learning methods can be applied in practical situations, such as developing applications for image recognition or natural language processing."
  },
  {
    "id": 85,
    "topic_id": 200,
    "title": "Understand the process of tokenization and embeddings.",
    "description": "Be able to understand how raw text is transformed into tokens, how chunking groups these tokens for context, and how embeddings convert these tokens into numerical vectors that capture semantic meaning. Recognize the importance of these steps for GenAI models."
  },
  {
    "id": 86,
    "topic_id": 200,
    "title": "Understand the Transformer architecture.",
    "description": "Understand the core principles of Transformer models, including the self-attention mechanism and its role in capturing relationships across tokens. Be prepared to discuss how Transformers process tokens in parallel and how this capability enhances context understanding and long-range dependency capture."
  },
  {
    "id": 87,
    "topic_id": 200,
    "title": "Grasp foundation and multi-modal AI concepts.",
    "description": "Understand that foundation models are large, pre-trained Transformer-based models that serve as versatile starting points for various applications. Recognize how the principles of tokenization, embeddings, and Transformers extend beyond text to other modalities, such as images, audio, and video. Be familiar with how multi-modal models—such as Vision Transformers and models like CLIP or DALL-E—integrate multiple data types to generate or analyze content."
  },
  {
    "id": 88,
    "topic_id": 200,
    "title": "Learn prompt engineering techniques.",
    "description": "Understand the strategies for crafting effective prompts, including contextual framing, role-playing, and few-shot prompting. Know how well-designed prompts can guide the output of large Transformer and multi-modal models and be aware of the balance between specificity and creative flexibility."
  },
  {
    "id": 89,
    "topic_id": 200,
    "title": "Evaluate the upsides and downsides of generative AI.",
    "description": "Be prepared to analyze the benefits of generative AI, such as its versatility, scalability, and efficiency in generating context-rich outputs, as well as its challenges, including hallucinations, interpretability issues, bias, and high computational costs. Understand the trade-offs involved and methods for mitigating potential risks."
  },
  {
    "id": 90,
    "topic_id": 200,
    "title": "Recognize applications where AI/ML can provide value.",
    "description": "Understand how AI/ML can assist human decision-making by analyzing large datasets, identifying patterns, and predicting outcomes. Applications include scalability for handling massive workloads and automation for repetitive tasks, enabling businesses to operate more efficiently."
  },
  {
    "id": 91,
    "topic_id": 200,
    "title": "Determine when AI/ML solutions are not appropriate. A",
    "description": "I/ML may not be the right choice in situations where cost outweighs the benefit, such as when the problem requires deterministic outcomes instead of predictions. These include scenarios where decisions must be based on predefined rules rather than learned patterns."
  },
  {
    "id": 92,
    "topic_id": 200,
    "title": "Select the appropriate ML techniques for specific use cases.",
    "description": "Understand the differences between regression, classification, and clustering to match ML techniques with the problem at hand. For instance, regression is ideal for predicting continuous values, classification for assigning categories, and clustering for grouping similar data points."
  },
  {
    "id": 93,
    "topic_id": 200,
    "title": "Identify examples of real-world AI applications.",
    "description": "Be able to identify where AI is applied in practice, such as computer vision (image recognition, object detection), natural language processing (chatbots, translation), speech recognition (voice assistants), recommendation systems (personalized content), and fraud detection (anomaly detection)."
  },
  {
    "id": 94,
    "topic_id": 200,
    "title": "Identify potential use cases for generative AI models.",
    "description": "Recognize where generative AI models can be applied, such as creating images, videos, and audio; generating summaries; building chatbots; translating text; assisting with code generation; and enhancing customer service through virtual agents, search, and recommendation engines."
  },
  {
    "id": 95,
    "topic_id": 200,
    "title": "Explain the capabilities of AWS managed AI/ML services.",
    "description": "Learn to categorize AWS services based on their functionality. AI services handle tasks like speech recognition, translation, and text-to-speech; ML services focus on model development and deployment using SageMaker; and Generative AI services like Bedrock and JumpStart support advanced use cases such as text and image generation."
  },
  {
    "id": 96,
    "topic_id": 200,
    "title": "Identify AWS services to develop generative AI applications.",
    "description": "Learn how AWS services like SageMaker JumpStart, Amazon Bedrock, PartyRock (an Amazon Bedrock Playground), and Amazon Q help streamline generative AI application development. These tools enable experimentation, customization, and deployment of foundational models to address various business use cases efficiently."
  },
  {
    "id": 97,
    "topic_id": 200,
    "title": "Describe the advantages of using AWS generative AI services.",
    "description": "AWS generative AI services provide significant advantages, such as lowering barriers to entry, improving efficiency, and reducing development time. They enable fast, cost-effective development of AI applications while ensuring accessibility to powerful models that align with business goals."
  },
  {
    "id": 98,
    "topic_id": 200,
    "title": "Understand the benefits of AWS infrastructure.",
    "description": "AWS infrastructure offers unparalleled benefits for generative AI, including built-in security, compliance, and operational reliability. Features like cost, availability, and scalability ensure your applications meet safety and performance standards."
  },
  {
    "id": 99,
    "topic_id": 200,
    "title": "Understand cost trade-offs of AWS generative AI services.",
    "description": "Evaluate the cost considerations of AWS generative AI services, such as token-based pricing, provisioned throughput, and regional redundancy. By understanding these trade-offs, you can optimize responsiveness, performance, and availability while managing expenses effectively."
  },
  {
    "id": 100,
    "topic_id": 200,
    "title": "Understand pre-trained model selection criteria.",
    "description": "Be able to select models based on factors such as cost, latency, model size, and customization needs. Know how to choose models for specific tasks, considering multi-lingual capabilities and input-output length requirements."
  },
  {
    "id": 101,
    "topic_id": 200,
    "title": "Analyze the impact of inference parameters.",
    "description": "Understand how temperature, input length, and output length affect model responses and performance. Be prepared to adjust these settings to optimize results for various applications."
  },
  {
    "id": 102,
    "topic_id": 200,
    "title": "Explain retrieval-augmented generation (RAG).",
    "description": "Understand how RAG enhances generative models by integrating external data sources, and recognize its practical applications in knowledge management and customer support. Familiarize yourself with RAG implementation on platforms like Amazon Bedrock."
  },
  {
    "id": 103,
    "topic_id": 200,
    "title": "Understand the basics of prompt engineering.",
    "description": "Be able to use common strategies in prompt engineering like role playing, structured output, thinking step by step to improve the performance of LLMs at a particular task."
  },
  {
    "id": 104,
    "topic_id": 200,
    "title": "Understand the cost performance trade-off.",
    "description": "While prompt engineering can convert verbose responses to brief ones, this may also impact the accuracy or performance at a particular task. On the other hand, detailed and clear prompts may cost more, but allow models to perform better at the task."
  },
  {
    "id": 105,
    "topic_id": 200,
    "title": "Understand business cases for retrieval-augmented generation (RAG).",
    "description": "Understand how retrieval-augmented generation combines generative AI models with a knowledge base to provide accurate, context-aware responses by retrieving relevant information during inference. Applications include creating dynamic customer support systems, summarizing large datasets, and enabling intelligent document search using solutions like Amazon Bedrock and integrated knowledge bases."
  },
  {
    "id": 106,
    "topic_id": 200,
    "title": "Identify AWS services to work with embeddings and vector embeddings.",
    "description": "Recognize the importance of vector databases in storing embeddings for semantic search and similarity matching. Determine which AWS services—such as Amazon OpenSearch Service, Amazon Aurora, Amazon Neptune, and so on—can provide scalable and efficient solutions for embedding storage and retrieval."
  },
  {
    "id": 107,
    "topic_id": 200,
    "title": "Understand the role of agents in intelligent autonomous workflows.",
    "description": "Understand how agents can be applied to automate workflows and how to build agents with configurations. Also understand the inner working of agentic systems, including how and when to use multi-agent workflows to orchestrate complex agentic AI systems on Amazon Bedrock."
  },
  {
    "id": 108,
    "topic_id": 200,
    "title": "Understand the data preparation process.",
    "description": "Recognize the importance of data curation, cleaning, labeling, and governance. Be prepared to discuss how ensuring representativeness, quality, and compliance in your datasets directly impacts a foundation model’s performance. Know why and how data pipelines are orchestrated to handle continuous updates."
  },
  {
    "id": 109,
    "topic_id": 200,
    "title": "Distinguish between pre-training and fine-tuning.",
    "description": "Understand that pre-training involves exposing a model to large, diverse datasets in an unsupervised or self-supervised manner to build general language or multi-modal capabilities. Fine-tuning then adapts this pre-trained model to a specific task or domain. Be able to explain methods like instruction tuning, domain adaptation, transfer learning, and continuous pre-training."
  },
  {
    "id": 110,
    "topic_id": 200,
    "title": "Recognize key performance metrics.",
    "description": "Be familiar with classical metrics (accuracy, AUC, F1 score) for classification tasks, and specialized metrics (ROUGE, BLEU, BERTScore) for language generation. Understand how these metrics fit into different stages of model development—initial training, iterative fine-tuning, and final validation."
  },
  {
    "id": 111,
    "topic_id": 200,
    "title": "Evaluate models beyond the numbers.",
    "description": "Appreciate that quantitative metrics don’t tell the whole story. Learn how human evaluation and benchmark datasets reveal nuances like coherence, fluency, and context relevance. Be prepared to discuss how these approaches complement automated metrics to create a holistic evaluation framework."
  },
  {
    "id": 112,
    "topic_id": 200,
    "title": "Incorporate business metrics.",
    "description": "Be ready to evaluate models on factors such as cost per user, development costs, ROI, and user engagement. Know how to balance technical metrics with operational considerations, ensuring that a foundation model is both effective and aligned with strategic business objectives."
  },
  {
    "id": 113,
    "topic_id": 200,
    "title": "Leverage AWS services for customization and evaluation.",
    "description": "Know how Amazon SageMaker can manage large-scale training, distributed fine-tuning, and model monitoring. Recognize how Amazon Bedrock offers foundation model evaluation capabilities, while SageMaker Clarify helps detect bias and assess fairness. Be prepared to discuss how these services streamline the entire lifecycle—from data processing to model deployment and continuous evaluation."
  },
  {
    "id": 114,
    "topic_id": 200,
    "title": "Understand the purpose of MLOps.",
    "description": "Be ready to explain how MLOps integrates people, processes, and tools to streamline the entire ML lifecycle—from experimentation to deployment and ongoing monitoring. Recognize the importance of collaboration across data science, engineering, and operations teams, and how this synergy reduces technical debt, accelerates time to market, and ensures more reliable, scalable solutions."
  },
  {
    "id": 115,
    "topic_id": 200,
    "title": "Identify the stages of an MLOps pipeline.",
    "description": "Know the key components of an ML pipeline: data collection, data preprocessing, feature engineering, model training, hyperparameter tuning, evaluation, deployment, and monitoring. Understand how each stage builds on the previous one, forming a repeatable, end-to-end process that can be automated and scaled. Be prepared to discuss how AWS services such as SageMaker, Data Wrangler, Feature Store, and Model Monitor fit into these stages."
  },
  {
    "id": 116,
    "topic_id": 200,
    "title": "Distinguish between experimentation and production readiness.",
    "description": "Appreciate the differences between rapid experimentation (testing multiple ideas, running quick prototypes) and production readiness (ensuring robust, secure, and scalable deployments). Understand how to leverage tools like SageMaker Pipelines, AWS Step Functions, and Apache Airflow to automate workflows and ensure that promising experimental models can quickly transition to production without sacrificing reliability."
  },
  {
    "id": 117,
    "topic_id": 200,
    "title": "Emphasize continuous monitoring and model maintenance.",
    "description": "Be prepared to explain the importance of tracking model performance and detecting issues like data drift or performance degradation. Know how AWS services such as SageMaker Model Monitor and CloudWatch help you set up alerts, collect metrics, and trigger retraining or redeployment. Understand that continuous improvement and feedback loops are essential for long-term model success in changing business environments."
  },
  {
    "id": 118,
    "topic_id": 200,
    "title": "Manage technical debt and scale efficiently.",
    "description": "Recognize how repeatable processes, version control, CI/CD, and IaC minimize technical debt. Know how to scale ML workflows and deployments by using auto-scaling endpoints, distributed training, and containerized environments on AWS. Be ready to discuss trade-offs between cost and performance, especially when dealing with large or complex models."
  },
  {
    "id": 119,
    "topic_id": 200,
    "title": "Differentiate inference types and deployment options.",
    "description": "Understand the key features of SageMaker Inference and how they help in deploying models efficiently. Be ready to discuss multi-model endpoints, custom inference scripts, and how to optimize performance for large or specialized models. Recognize how techniques like Parameter Efficient Fine-Tuning (PEFT) and Triton-based multi-model serving can help manage multiple models within a single environment."
  },
  {
    "id": 120,
    "topic_id": 200,
    "title": "Explain the development of AI systems that are responsible.",
    "description": "Understand the principles of responsible AI, including fairness, transparency, privacy, and security in AI development. Learn how governance, bias detection, and ethical AI design frameworks help ensure AI systems operate safely and align with business and regulatory requirements."
  },
  {
    "id": 121,
    "topic_id": 200,
    "title": "Recognize the importance of transparent and explainable models.",
    "description": "Understand why explainability and transparency are critical for trust in AI, particularly in high-stakes industries like healthcare and finance. Learn how techniques such as feature attributions, model documentation, and monitoring enable users to understand and trust AI-generated outputs."
  },
  {
    "id": 122,
    "topic_id": 200,
    "title": "Identify the role of governance in AI lifecycle management.",
    "description": "Learn how AI governance frameworks help define policy enforcement, access control, risk mitigation, and compliance in AI model development. Understand how organizations implement governance to track model usage, ensure regulatory adherence, and manage AI risks."
  },
  {
    "id": 123,
    "topic_id": 200,
    "title": "Understand the importance of continuous model monitoring.",
    "description": "Recognize why ongoing model monitoring is essential to detect bias, data drift, and performance degradation over time. Learn how monitoring strategies enable proactive interventions, retraining, and fine-tuning to maintain model reliability in production."
  },
  {
    "id": 124,
    "topic_id": 200,
    "title": "Understand the role of evaluations in Responsible AI.",
    "description": "Learn how automated model evaluations help assess AI performance, accuracy, fairness, and robustness. Understand how evaluation frameworks ensure models are safe for deployment and identify potential risks before models go into production."
  },
  {
    "id": 125,
    "topic_id": 200,
    "title": "Understand the shared responsibility model in AI security.",
    "description": "Recognize that AWS manages the security of the cloud infrastructure, while users are responsible for securing their data and applications within the cloud. Be able to explain how this model applies to AI services like Amazon Bedrock."
  },
  {
    "id": 126,
    "topic_id": 200,
    "title": "Identify AI-specific vulnerabilities and threats.",
    "description": "Be familiar with common AI security risks, such as prompt injection, model poisoning, and adversarial attacks. Understand how frameworks like MITRE’s ATLAS can help identify and mitigate these threats."
  },
  {
    "id": 127,
    "topic_id": 200,
    "title": "Explain the Generative AI Security Scoping Matrix.",
    "description": "Know the five scopes of AI deployment and the corresponding security measures for each. Be prepared to discuss how security requirements shift based on the deployment model and intended use of generative AI systems."
  },
  {
    "id": 128,
    "topic_id": 200,
    "title": "Understand data governance strategies in AI systems.",
    "description": "Be able to explain the importance of data lifecycle management, logging, and documentation in ensuring transparency, accountability, and compliance. Recognize the role of data residency and sovereignty in global AI deployments."
  },
  {
    "id": 129,
    "topic_id": 200,
    "title": "Recognize key compliance frameworks and regulations.",
    "description": "Be familiar with GDPR, HIPAA, and ISO standards, and understand how they apply to AI systems. Know how AWS services like AWS Config, AWS Audit Manager, and AWS Artifact help organizations meet these compliance requirements."
  },
  {
    "id": 130,
    "topic_id": 200,
    "title": "Evaluate AWS tools for AI security and compliance.",
    "description": "Understand the roles of AWS Config for resource configuration monitoring, AWS Audit Manager for automating compliance assessments, and AWS Artifact for accessing compliance reports. Be able to explain how these tools support secure and compliant AI deployments."
  },
  {
    "id": 131,
    "topic_id": 200,
    "title": "Analyze real-world AI security challenges.",
    "description": "Be prepared to discuss case studies that illustrate AI security risks, such as prompt injection attacks, supply chain vulnerabilities, and data exfiltration. Understand the mitigation strategies and best practices for addressing these challenges."
  }
];
